module.exports = __webpack_public_path__ + "static/media/favicon.71fe27f5.png";